module.exports = __webpack_public_path__ + "static/media/5-min.bfb30025.jpg";